import UpsaleCardWide from './UpsaleCardWide'

export default UpsaleCardWide
